import { lazy } from "react";

const routes = [
  {
    component: lazy(() => import("./pages/Applications")),
    path: "/",
    exact: true
  },
  {
    component: lazy(() => import("./pages/Applications")),
    path: "/applications",
    exact: true
  },
  {
    component: lazy(() => import("./pages/Application")),
    path: "/applications/:applicationId",
    exact: true
  },
  {
    component: lazy(() => import("./pages/UserSettings")),
    path: "/user/settings",
    exact: true
  },
  {
    component: lazy(() => import("./pages/AccountSettings")),
    path: "/account/settings",
    exact: true
  }
];

export default routes;
